import React from 'react'

import BaseLayout from '../../common/components/BaseLayout'

import HCFRIncidentList from '../../hcfr/components/HCFRIncidentList'

import styles from './MainLayout.module.css'

const MainLayout = () => {
  return (
    <BaseLayout title="HCFR Active Incidents">
      <div style={{ marginTop: 50, display: 'flex' }}>
        <div className={styles.container}>
          <HCFRIncidentList />
        </div>
      </div>
    </BaseLayout>
  )
}

export default MainLayout
